require('./RAAccountBox.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const CurrencyHelper = require('utilities/currencyHelper');

// @components
const RACircularGoalIcon = require('../RACircularGoalIcon/RACircularGoalIcon');

// @constants
const { EURO_SYMBOL } = require('constants/index');

class RAAccountBox extends React.Component {
    buildFooter(netValue) {
        const netValueAmount = CurrencyHelper.getFormattedString({
            amount: netValue,
            currency: EURO_SYMBOL,
        });

        return (
            <div className="ra-account-box__footer">
                <div className="row">
                    <div className="col-md-6">
                        <h2 className="ra-account-box__title">
                            <FormattedText value="raRefundRequest-refundAmount" />
                        </h2>
                    </div>
                    <div className="col-md-6">
                        <div className="ra-account-box__item-col-last">
                            <FormattedText
                                className="ra-account-box__item-title"
                                value="raCancelPlan-netValueTitle"
                            />
                            <span className="ra-account-box__item-value">
                                {netValueAmount}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {
            //accountName,
            accountOwner,
            currentValue,
            iconType,
            goalModifier,
            netValue,
            showAmountToRefund,
            productIcon,
            productName,
        } = this.props;
        const currentValueAmount = CurrencyHelper.getFormattedString({
            amount: currentValue,
            currency: EURO_SYMBOL,
        });
        const footer = showAmountToRefund ? this.buildFooter(netValue) : null;
        let icon = (
            <img
                className="ra-account-box__product-icon"
                src={productIcon}
                alt=""
                aria-hidden
            />
        );
        if (iconType) {
            icon = (
                <RACircularGoalIcon
                    type={iconType}
                    modifier={goalModifier}
                    size="small"
                />
            );
        }

        return (
            <div className="ra-account-box">
                <div className="ra-account-box__body">
                    <div>
                        {icon}
                        <h2 className="ra-account-box__title">{productName}</h2>
                    </div>
                    <div className="row ra-account-box__info-section">
                        <div className="col-md-6 print-label">
                            {/*<div>
                                <FormattedText
                                    className="ra-account-box__item-title"
                                    value="raCancelPlan-associatedAccountInfo"
                                />
                                <span className="ra-account-box__item-value">{accountName}</span>
                            </div>
                            */}
                            <div className="ra-account-box__owner-section">
                                <FormattedText
                                    className="ra-account-box__item-title"
                                    value="raCancelPlan-ownerInfo"
                                />
                                <span className="ra-account-box__item-value">
                                    {accountOwner}
                                </span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="ra-account-box__item-col-last">
                                <FormattedText
                                    className="ra-account-box__item-title"
                                    value="raCancelPlan-currentValueInfo"
                                />
                                <span className="ra-account-box__item-value">
                                    {currentValueAmount}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                {footer}
            </div>
        );
    }
}

RAAccountBox.propTypes = {
    iconType: PropTypes.string,
    productIcon: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    accountName: PropTypes.string,
    accountOwner: PropTypes.string,
    currentValue: PropTypes.number,
    goalModifier: PropTypes.string,
    netValue: PropTypes.number,
    showAmountToRefund: PropTypes.bool,
    name: PropTypes.string,
};

RAAccountBox.defaultProps = {
    showAmountToRefund: false,
};

module.exports = RAAccountBox;
